module.exports = __webpack_public_path__ + "img/accompagnement.cbbe9b61.png";